import { Component, OnInit } from "@angular/core";
import { ImageService } from "src/app/services/imagen.service";

@Component({
  selector: "app-search-img",
  templateUrl: "./search-img.component.html",
  styleUrls: ["./search-img.component.scss"],
})
export class SearchImgComponent implements OnInit {
  nameImage: string = "";

  constructor(private _imageService: ImageService) {}

  ngOnInit() {
    Array.from("bosque").forEach((element, index) => {
      setTimeout(() => {
        if (index === 5) {
          this.nameImage = this.nameImage + element;
          this.onSearchImage();
        } else {
          this.nameImage = this.nameImage + element;
        }
      }, index * 200);
    });
  }
  onSearchImage() {
    if (!this.nameImage.length) {
      this._imageService.setError("Agrega un texto de busqueda");
      return;
    }

    this._imageService.setTermSearch(this.nameImage);
  }
}
